import { render, staticRenderFns } from "./SalesReg.vue?vue&type=template&id=05367dd6"
import script from "./SalesReg.vue?vue&type=script&lang=js"
export * from "./SalesReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports